export enum CardCollectionsTemplateProps {
  Card_Grid = 'cardGrid',
  Card_Grid_nextGen = 'card-grid-nextGen',
  Card_List = 'cardList',
  Card_List_nextGen = 'card-list-nextGen',
  Card_Carousel = 'cardCarousel',
  Card_Carousel_nextGen = 'card-carousel-nextGen',
  Card_Background = 'cardBackground',
  Card_Footer = 'cardFooter',
  Card_Image_Only = 'card-image-only',
  Card_Person = 'card-person',
}
